<button
  mat-icon-button
  class="ground-button"
  aria-label="Side panel grounding button"
  (click)="groundCuboid()"
>
  <mat-icon class="ground-icon">vertical_align_bottom</mat-icon>
</button>
